import React, { useState } from "react";
import classes from "./Carrusel.module.css";
import ImagenLanding1 from "../../../../assets/images/carrusel/optimizadas/Landing1.png";
import ImagenLanding2 from "../../../../assets/images/carrusel/optimizadas/Landing2.png";
import ImagenLanding3 from "../../../../assets/images/carrusel/optimizadas/Landing3.png";
import ImagenLanding4 from "../../../../assets/images/carrusel/optimizadas/Landing4.png";
import Slide from "./Slide/Slide";

const Carrusel = () => {
  const [slideActivo, setSlideActivo] = useState(0);

  const textoSlide1 = (
    <>
      Navegación <strong>fácil, fluida y simplificada,</strong> con experiencia
      de usuario <strong>mejorada y coherente</strong> a través de una interfaz
      <br />
      <strong>intuitiva y responsiva</strong>
    </>
  );

  const textoSlide2 = (
    <>
      Brindar una <strong>única plataforma</strong> de acceso al vecino que
      reduce la necesidad de múltiples autenticaciones.
    </>
  );

  const textoSlide3 = (
    <>
      Mejorar la <strong>accesibilidad</strong> de los adultos mayores mediante
      una interfaz especialmente adaptada a estos ciudadanos
    </>
  );

  const textoSlide4 = (
    <>
      Mejorar la <strong>comunicación</strong> con los ciudadanos mediante el
      envío de notificaciones.
    </>
  );

  const infoSlides = [
    {
      texto: textoSlide1,
      imagen: ImagenLanding1,
    },
    {
      texto: textoSlide2,
      imagen: ImagenLanding2,
    },
    {
      texto: textoSlide3,
      imagen: ImagenLanding3,
    },
    {
      texto: textoSlide4,
      imagen: ImagenLanding4,
    },
  ];

  setTimeout(() => {
    if (slideActivo === infoSlides.length - 1) setSlideActivo(0);
    else setSlideActivo(slideActivo + 1);
  }, 6000);

  return (
    <>
      <div className={classes.carruselContainer}>
        <div className={classes.carruselViewport}>
          {infoSlides.map((slide, index) => (
            <Slide
              info={slide}
              activo={index === slideActivo}
              key={index}
            ></Slide>
          ))}
        </div>
      </div>
    </>
  );
};

export default Carrusel;
